import { useMemo, useState } from 'react';
export const getInputBorderColor = (isFocused, hasError, isDisabled) => {
    if (isDisabled) {
        return 'neutralBorderWeakDisabled';
    }
    if (isFocused) {
        return 'baseBorder';
    }
    if (hasError) {
        return 'dangerBorder';
    }
    return 'neutralBorder';
};
export const useStoryBookDropdownProps = (itemsCount) => {
    const [selectedKey, setSelectedKey] = useState(null);
    const dropdownItems = useMemo(() => Array.from({ length: itemsCount })
        .fill(undefined)
        .map((_, index) => ({
        key: index.toString(),
        content: `Item ${index + 1}`,
    })), [itemsCount]);
    return {
        id: 'storybookDropdown',
        value: selectedKey,
        onChange: setSelectedKey,
        items: dropdownItems,
    };
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXRpbHMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvY29tcG9uZW50cy9jb21tb25zL0Nob2NvRm9ybS91dGlscy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxPQUFPLEVBQUUsT0FBTyxFQUFFLFFBQVEsRUFBRSxNQUFNLE9BQU8sQ0FBQztBQUkxQyxNQUFNLENBQUMsTUFBTSxtQkFBbUIsR0FBRyxDQUNqQyxTQUFrQixFQUNsQixRQUFpQixFQUNqQixVQUFtQixFQUNuQixFQUFFO0lBQ0YsSUFBSSxVQUFVLEVBQUU7UUFDZCxPQUFPLDJCQUEyQixDQUFDO0tBQ3BDO0lBRUQsSUFBSSxTQUFTLEVBQUU7UUFDYixPQUFPLFlBQVksQ0FBQztLQUNyQjtJQUVELElBQUksUUFBUSxFQUFFO1FBQ1osT0FBTyxjQUFjLENBQUM7S0FDdkI7SUFFRCxPQUFPLGVBQWUsQ0FBQztBQUN6QixDQUFDLENBQUM7QUFFRixNQUFNLENBQUMsTUFBTSx5QkFBeUIsR0FBRyxDQUFDLFVBQWtCLEVBQUUsRUFBRTtJQUM5RCxNQUFNLENBQUMsV0FBVyxFQUFFLGNBQWMsQ0FBQyxHQUFHLFFBQVEsQ0FBZ0IsSUFBSSxDQUFDLENBQUM7SUFFcEUsTUFBTSxhQUFhLEdBQXVDLE9BQU8sQ0FDL0QsR0FBRyxFQUFFLENBQ0gsS0FBSyxDQUFDLElBQUksQ0FBQyxFQUFFLE1BQU0sRUFBRSxVQUFVLEVBQUUsQ0FBQztTQUMvQixJQUFJLENBQUMsU0FBUyxDQUFDO1NBQ2YsR0FBRyxDQUFDLENBQUMsQ0FBQyxFQUFFLEtBQUssRUFBRSxFQUFFLENBQUMsQ0FBQztRQUNsQixHQUFHLEVBQUUsS0FBSyxDQUFDLFFBQVEsRUFBRTtRQUNyQixPQUFPLEVBQUUsUUFBUSxLQUFLLEdBQUcsQ0FBQyxFQUFFO0tBQzdCLENBQUMsQ0FBQyxFQUNQLENBQUMsVUFBVSxDQUFDLENBQ2IsQ0FBQztJQUVGLE9BQU87UUFDTCxFQUFFLEVBQUUsbUJBQW1CO1FBQ3ZCLEtBQUssRUFBRSxXQUFXO1FBQ2xCLFFBQVEsRUFBRSxjQUFjO1FBQ3hCLEtBQUssRUFBRSxhQUFhO0tBQ3JCLENBQUM7QUFDSixDQUFDLENBQUMifQ==